import React from 'react';

export type Curriculum = 'British' | 'American' | 'IB' | 'Indian CBSE' | 'Indian ICSE' | 'French' | 'MOE Arabic';

interface CurriculumBadgeProps {
  curriculum: Curriculum;
  size?: 'sm' | 'md';
}

const curriculumConfig: Record<Curriculum, { bg: string; text: string }> = {
  British: { bg: 'bg-blue-50', text: 'text-blue-700' },
  American: { bg: 'bg-red-50', text: 'text-red-700' },
  IB: { bg: 'bg-purple-50', text: 'text-purple-700' },
  'Indian CBSE': { bg: 'bg-orange-50', text: 'text-orange-700' },
  'Indian ICSE': { bg: 'bg-yellow-50', text: 'text-yellow-700' },
  French: { bg: 'bg-indigo-50', text: 'text-indigo-700' },
  'MOE Arabic': { bg: 'bg-teal-50', text: 'text-teal-700' },
};

export default function CurriculumBadge({ curriculum, size = 'md' }: CurriculumBadgeProps) {
  const config = curriculumConfig[curriculum] ?? { bg: 'bg-gray-50', text: 'text-gray-700' };
  return (
    <span
      className={`inline-flex items-center font-medium rounded-md border border-transparent ${config.bg} ${config.text} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'
      }`}
    >
      {curriculum}
    </span>
  );
}